/* eslint-disable @scandipwa/scandipwa-guidelines/use-namespace,@scandipwa/scandipwa-guidelines/derived-class-names */
/**
 * @category    ScandiPWA
 * @package     ScandiPWA_CjPublicis
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2022 Scandiweb, Ltd (https://scandiweb.com)
 */

import { Field } from 'Util/Query';

export class OrderDataQuery {
    getOrderDataQuery = (orderId) => new Field('getOrderData')
        .addArgument('orderID', 'String!', orderId)
        .addFieldList(this.getData());

    getData = () => ([
        'lineItems',
        'quantities',
        'prices',
        'discounts',
        'enterpriseId',
        'orderId',
        'actionTrackerId',
        'currency',
        'amount',
        'taxAmount',
        'discount',
        'coupon',
        'customerCountry',
        'customerStatus',
        'userId',
        'emailHash',
        'cjPlugin'
    ]);
}

export default new OrderDataQuery();
